import {TTabForm} from '../policies/policiesTypes'

export const TABS_FORM: {name: string; description: string; tabName: TTabForm; icon: string}[] = [
  {
    name: 'Policy Holder',
    description: 'Contact Information',
    icon: 'bi bi-person-vcard',
    tabName: 'policy-holder',
  },
  // {
  //   name: 'Quote information',
  //   description: 'Specific information',
  //   icon: 'bi bi-list-check',
  //   tabName: 'policy-info',
  // },
  {
    name: 'Address information',
    description: 'Address information',
    icon: 'bi bi-geo',
    tabName: 'address-info',
  },
  {
    name: 'Household information',
    description: 'Household information',
    icon: 'bi bi-person-lines-fill',
    tabName: 'household-info',
  },
  {
    name: 'Basic quote information',
    description: 'Complete',
    icon: 'bi bi-stars',
    tabName: 'basic-policy-info',
  },
   {
    name: 'Request Consent',
    description: 'Request Consent',
    icon: 'bi bi-vector-pen',
    tabName: 'request-consent',
  },
]
